'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { Record, Map as ImmutableMap } from 'immutable';
import { FORM_FIELD_TYPES } from 'MeetingsBase/constants/enums';

function getInitialCustomFieldState(formFields) {
  return formFields.reduce(function (acc, field) {
    if (field.fieldType === FORM_FIELD_TYPES.BOOLEAN_CHECKBOX) {
      return acc.set(field.name, false);
    } else if (field.fieldType === FORM_FIELD_TYPES.CHECKBOX) {
      return acc.set(field.name, []);
    } else {
      return acc.set(field.name, null);
    }
  }, new ImmutableMap());
}

var defaults = {
  email: '',
  firstName: '',
  lastName: '',
  customFormFields: new ImmutableMap(),
  originalFormState: null
};

var FormState = /*#__PURE__*/function (_Record) {
  _inherits(FormState, _Record);

  function FormState() {
    _classCallCheck(this, FormState);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormState).apply(this, arguments));
  }

  _createClass(FormState, null, [{
    key: "from",
    value: function from(json) {
      json.customFormFields = new ImmutableMap(json.customFormFields);
      var jsonMap = ImmutableMap(json).filter(function (value) {
        return value !== undefined;
      });
      return new FormState(jsonMap);
    }
  }, {
    key: "customFieldsFromBookInfo",
    value: function customFieldsFromBookInfo(json) {
      var formFields = json.customParams.formFields;
      var customFormFields = getInitialCustomFieldState(formFields);
      return customFormFields;
    }
  }]);

  return FormState;
}(Record(defaults));

export { FormState as default };